import { useWebStoreContext } from "contexts/WebStoreProvider";
import { IShopLoyaltyOffer } from "contexts/WebStoreProvider/types";
import { SingleItemsSkeleton } from "../../skeleton";
import { useContext, useEffect, useState } from "react";
import { offersApi } from "redux/apis";
import { LoyaltyContext } from "../../index";
import LoyaltyOfferSection from "./components/LoyaltyOfferSection";
import { useDispatch } from "react-redux";
import { ISectionMenuItem } from "components/PageTopNav";
import { sortByPriority } from "utils/sort";

const SingleItems = () => {
	const { store, authToken } = useWebStoreContext();
	const [content, setContent] = useState<JSX.Element[]>();
	const dispatch = useDispatch();
	//const { newDay } = useNewDay();

	const { data: loyaltyOffers } = offersApi.endpoints.getOffers.useQueryState({
		offerType: "loyalty",
		isAuthenticated: !!authToken?.value
	});

	const { sectionMenuData } = useContext(LoyaltyContext);

	useEffect(() => {
		if (
			!store?.loyaltyShopSections ||
			!loyaltyOffers ||
			!sectionMenuData.length
		) {
			return;
		}
		setContent(
			store?.loyaltyShopSections
				.filter((data) =>
					loyaltyOffers.offers?.find(
						(of: IShopLoyaltyOffer) => of.sectionName === data.name
					)
				)
				.map((data) => {
					const sectionOffers = sortByPriority(
						loyaltyOffers?.offers.filter(
							(of: IShopLoyaltyOffer) => of.sectionName === data.name
						)
					);
					const sectionProps = {
						data,
						sectionRef: sectionMenuData.find(
							(item: ISectionMenuItem) => item.name === data.name
						)?.sectionRef,
						uniqueKey: data.name
					};

					return (
						<LoyaltyOfferSection
							{...sectionProps}
							key={data.name}
							sectionOffers={sectionOffers as IShopLoyaltyOffer[]}
						/>
					);
				})
		);
	}, [loyaltyOffers, sectionMenuData]);

	useEffect(() => {
		dispatch(
			offersApi.util.invalidateTags([
				{
					type: "offersTag",
					id: "loyalty"
				}
			])
		);
	}, [sectionMenuData]);

	// useEffect(() => {
	// 	if (newDay) {
	// 		refetch();
	// 	}
	// }, [newDay]);

	if (!content) {
		return <SingleItemsSkeleton />;
	}

	return <>{content}</>;
};

export default SingleItems;
